export const FETCH_AUDIENCES = "audience/FETCH_AUDIENCES";
export const FETCH_AUDIENCES_SUCCESS = "audience/FETCH_AUDIENCES_SUCCESS";